import { YStack, Text } from 'tamagui'
import { useTranslation } from 'react-i18next'

// Estado de produto/curso não encontrado, renderizado in place (sem redirect
// de volta ao core — evitaria loop com o roteamento do nginx).
export function NotFoundState() {
  const { t } = useTranslation('ProductPage')

  return (
    <YStack
      flex={1}
      minHeight="100%"
      alignItems="center"
      justifyContent="center"
      backgroundColor="$bg-page"
      padding="$size.spacing-lg"
      gap="$size.spacing-xs"
    >
      <Text
        color="$text-primary"
        fontSize="$font-size-md"
        fontFamily="$mulishBold"
      >
        {t('notFound.title')}
      </Text>
      <Text
        color="$text-secondary"
        fontSize="$font-size-xs"
        fontFamily="$mulishRegular"
        textAlign="center"
      >
        {t('notFound.description')}
      </Text>
    </YStack>
  )
}
